import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import Action from '@components/Action'
import Add from '@components/Icon/Add'

class Actions extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    parentAccount: PropTypes.object,
    history: PropTypes.object
  }

  render () {
    return (
      <div className='actions-wrapper'>
        <ul className='actions'>
          <li
            data-cy='create-invoicing-entity-btn'
            className='action'
            onClick={() => {
              return this.props.modalStore.show({
                type: 'INVOICING_ENTITY_FORM',
                props: {
                  parentAccount: this.props.parentAccount,
                  onSaveSuccess: invoicingEntity => {
                    const { parentAccountId, id } = invoicingEntity
                    this.props.history.push(
                      `/parent-account/${parentAccountId}/invoicing-entities/${id}`
                    )

                    this.props.modalStore.close()
                  }
                }
              })
            }}
          >
            <Action>
              <Add />
              <span>Create invoicing entity</span>
            </Action>
          </li>
        </ul>
      </div>
    )
  }
}

export default withRouter(inject('modalStore')(observer(Actions)))
